<template>
    <div class="pr-1 pl-3 pt-1">
        <div class="v-flex w-100">
            <div class="w-50 pr-2">
                <c-name-value-header :title = "$t('unit.escalator.tzb.drive')" />
                <c-rating-row     label="Bewertung"                                                                         :data="drive" />
                <c-name-value-row :label="$t('unit.escalator.tzb.driveType')"     property="type"         type="siteTzbEscalatorEngineType"    :data="drive" />
                <c-name-value-row :label="$t('unit.tzb.manufacturer')"            property="manufacturer" type="manufacturer"                  :data="drive" />
                <c-name-value-row :label="$t('unit.escalator.model')"             property="model"                                             :data="drive" />
            </div>

            <div class="w-50 pl-2">
                <c-name-value-header :title = "$t('unit.escalator.tzb.automatic')" />
                <c-rating-row     label="Bewertung"                                                                         :data="automatic" />
                <c-name-value-row :label="$t('unit.escalator.tzb.automaticType')" property="type"         type="siteTzbEscalatorAutomaticType" :data="automatic" />
                <c-name-value-row :label="$t('unit.tzb.manufacturer')"            property="manufacturer" type="manufacturer"                  :data="automatic" />
                <c-name-value-row :label="$t('unit.escalator.model')"             property="model"                                             :data="automatic" />
            </div>
        </div>

        <div class="v-flex w-100 mt-8">
            <div class="w-50 pr-2">
                <c-name-value-header :title = "$t('unit.escalator.tzb.control')" />
                <c-rating-row     label="Bewertung"                                                                         :data="control" />
                <c-name-value-row :label="$t('unit.escalator.tzb.controlType')"   property="type"         type="siteTzbEscalatorControlType"   :data="control" />
                <c-name-value-row :label="$t('unit.tzb.manufacturer')"            property="manufacturer" type="manufacturer"                  :data="control" />
                <c-name-value-row :label="$t('unit.escalator.model')"             property="model"                                             :data="control" />
            </div>

            <div class="w-50 pl-2">
                <c-name-value-header title = "Bauteile" />
                <c-rating-row :label="$t('unit.escalator.tzb.handrails')"    property="handrails"    :data="escalator" />
                <div v-if="hasText(escalator.handrailsNotice)" class="part-notice lm-border pa-2 mb-1">{{ escalator.handrailsNotice }}</div>
                <c-rating-row :label="$t('unit.escalator.tzb.balustrade')"   property="balustrade"   :data="escalator" />
                <div v-if="hasText(escalator.balustradeNotice)" class="part-notice lm-border pa-2 mb-1">{{ escalator.balustradeNotice }}</div>
                <c-rating-row :label="$t('unit.escalator.tzb.socle')"        property="socle"        :data="escalator" />
                <div v-if="hasText(escalator.socleNotice)" class="part-notice lm-border pa-2 mb-1">{{ escalator.socleNotice }}</div>
                <c-rating-row :label="$t('unit.escalator.tzb.socleBrushes')" property="socleBrushes" :data="escalator" />
                <div v-if="hasText(escalator.socleBrushesNotice)" class="part-notice lm-border pa-2 mb-1">{{ escalator.socleBrushesNotice }}</div>
                <c-rating-row :label="$t('unit.escalator.tzb.steps')"        property="steps"        :data="escalator" />
                <div v-if="hasText(escalator.stepsNotice)" class="part-notice lm-border pa-2 mb-1">{{ escalator.stepsNotice }}</div>
                <c-rating-row :label="$t('unit.escalator.tzb.combs')"        property="combs"        :data="escalator" />
                <div v-if="hasText(escalator.combsNotice)" class="part-notice lm-border pa-2 mb-1">{{ escalator.combsNotice }}</div>
            </div>
        </div>

        <div class="v-flex w-100 mt-8">
            <div class="w-50 pr-2">
                <c-name-value-header title = "Anlagenzustand" />
                <c-rating-row label="Bewertung" property="unitRating" :data="escalator" />

                <div v-if="hasText(escalator.unitNotice)" class="part-notice lm-border pa-2 mt-1">{{ escalator.unitNotice }}</div>
            </div>

            <div class="w-50 pl-2">
                <c-name-value-header :title = "$t('unit.escalator.tzb.maintenance')" />
                <c-rating-row     label="Bewertung"                                                                :data="maintenance" />
                <c-name-value-row :label="$t('unit.escalator.tzb.company')" property="service" type="servicecompanies" :data="maintenance" />

                <div class="notice lm-border pa-2 mt-1">
                    {{ maintenance.notice }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CNameValueHeader from "@/modules/dis/components/inspection/common/components/CNameValueHeader.vue";
import CNameValueRow    from "@/modules/dis/components/inspection/common/components/CNameValueRow.vue";
import CRatingRow       from "@/modules/dis/components/inspection/common/components/CRatingRow.vue";

/**
 * Escalator TZB of an inspection in the disposition (`condition.escalator`, HCIT-979, HCIT-1143): drive, control system
 * and regulation with type, manufacturer and model, the component ratings, the unit state and the maintenance. Ratings
 * are 1 good, 2 satisfactory, 3 deficient. The notes of the components and the unit state captured in the app
 * (`*Notice`, HCIT-1195) are shown below their rating, nothing if empty.
 */
export default {
    name: "PDispositionConditionEscalator",
    components: {
        CRatingRow,
        CNameValueRow,
        CNameValueHeader,
    },

    props: {
        escalator: {
            type    : Object,
            required: false,
            default : function () {
                return {};
            }
        },
    },

    computed: {
        drive () {
            return this.escalator.drive || {};
        },

        automatic () {
            return this.escalator.automatic || {};
        },

        control () {
            return this.escalator.control || {};
        },

        maintenance () {
            return this.escalator.maintenance || {};
        },
    },

    methods: {
        hasText (value) {
            return typeof value === "string" && value.trim().length > 0;
        },
    },
}
</script>

<style scoped>

.notice {
    width: 100%;
    height: 90px;
}

.part-notice {
    width: 100%;
    font-size: 13px;
    white-space: pre-line;
    overflow-wrap: anywhere;
}

</style>
